export const formatKoreanNumber = (num: number) => {
  const remainder = num % 10000;
  const thousand_text = `${remainder / 1000}천원`;

  if (num < 10000) {
    return thousand_text;
  }

  const quotient = Math.floor(num / 10000);

  let result = `${quotient}만원`;
  if (remainder > 0) {
    result += ` ${thousand_text}`;
  }

  return result;
};
